import { __awaiter, __generator } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Chip, Box } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EventIcon from "@mui/icons-material/Event";
import LockIcon from "@mui/icons-material/Lock";
import { useDispatch } from "react-redux";
import { setLoading, setModal, setSnackbar } from "../../store/slices";
import { ModalKeys } from "../../components/modal/modalKeys";
import { TripMemberStatus } from "../../utils/enums/TripMemberStatus";
import { getTripDetails, tripMembershipAction, } from "../../services/api/TripDetailsService";
import { inviteUsersToTrip } from "../../services/api/EventCreationServices";
import useApiWrapper from "../../hooks/apiWrapper";
import tripPrivacyDetails from "../../components/common/trip-privacy/tripPrivacyDetails";
import FeaturedIn from "../../components/common/featured-in/featured-in";
import DetailsCard from "../../components/common/details-card/DetailsCard";
import TripActionButtons from "../../components/buttons/trip-actions/TripActionButtons";
import Goa from "./../../assets/images/goa.avif";
import { CustomButton, CustomCardWrapper, CustomIcon, CustomText, WrapperContainer, } from "@corporate-trip-planner-fe/ui-styles";
import { TripDetailsBody } from "./trip-details.style";
import { TripGallery } from "@corporate-trip-planner-fe/ui-components";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import CheckIcon from "@mui/icons-material/Check";
import { getImageUrl } from "../../utils/helpers/functions";
var TripDetails = function () {
    var _a, _b, _c, _d, _e;
    var dispatch = useDispatch();
    var tripId = useParams().tripId;
    var _f = useState(null), trip = _f[0], setTripDetails = _f[1];
    var _g = useState(TripMemberStatus.NOT_JOINED), userStatus = _g[0], setUserStatus = _g[1];
    var _h = useState(false), actionLoading = _h[0], setActionLoading = _h[1];
    var apiWrapper = useApiWrapper().apiWrapper;
    var tripPrivacyInfo = tripPrivacyDetails[trip === null || trip === void 0 ? void 0 : trip.privacySetting];
    // Fetch Trip Details
    var fetchTripDetails = function (tripId) { return __awaiter(void 0, void 0, void 0, function () {
        var res, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(setLoading(true));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, getTripDetails(tripId)];
                case 2:
                    res = _a.sent();
                    setTripDetails(res);
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    console.error("Error fetching trip details:", err_1);
                    dispatch(setSnackbar({
                        message: "Failed to fetch trip details",
                        severity: "error",
                        open: true,
                    }));
                    return [3 /*break*/, 5];
                case 4:
                    dispatch(setLoading(false));
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var submitInviteUsers = function (tripId, payload) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    return [4 /*yield*/, apiWrapper(function () { return inviteUsersToTrip(tripId, payload); })];
                case 1:
                    _a.sent();
                    dispatch(setSnackbar({
                        message: "Invites sent successfully",
                        severity: "success",
                        open: true,
                    }));
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    dispatch(setSnackbar({
                        message: "Some issue occurred",
                        severity: "error",
                        open: true,
                    }));
                    return [3 /*break*/, 4];
                case 3:
                    dispatch(setLoading(false));
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleInviteUsersClick = function () {
        dispatch(setModal({
            name: ModalKeys.INVITE_USERS,
            props: {
                tripId: tripId,
                tripName: trip === null || trip === void 0 ? void 0 : trip.tripName,
                onSubmit: submitInviteUsers,
            },
        }));
    };
    var handleTripMembershipAction = function (tripId, action) { return __awaiter(void 0, void 0, void 0, function () {
        var res, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setActionLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, apiWrapper(function () {
                            return tripMembershipAction({ tripId: tripId, action: action });
                        })];
                case 2:
                    res = _a.sent();
                    if (res.result && res.result.updatedStatus) {
                        setUserStatus(res.result.updatedStatus);
                    }
                    dispatch(setSnackbar({
                        message: res.message,
                        severity: [2107, 2112].includes(res.statusCode) ? "success" : "error",
                        open: true,
                    }));
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _a.sent();
                    console.error(error_2);
                    dispatch(setSnackbar({
                        message: "Some issue occurred",
                        severity: "error",
                        open: true,
                    }));
                    return [3 /*break*/, 5];
                case 4:
                    setActionLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var formatTripDate = function (dateString) {
        if (!dateString)
            return "";
        var _a = dateString.split("-").map(Number), day = _a[0], month = _a[1], year = _a[2];
        var date = new Date(year, month - 1, day);
        return date.toLocaleDateString("en-IN", {
            day: "numeric",
            month: "short",
            year: "numeric",
        });
    };
    useEffect(function () {
        if (trip) {
            setUserStatus(trip.userStatus);
        }
    }, [trip]);
    useEffect(function () {
        if (tripId)
            fetchTripDetails(tripId);
    }, []);
    return (_jsx(WrapperContainer, { "$margin": "5rem 0 0 0", "$padding": "0", children: trip && (_jsxs(WrapperContainer, { "$flexDirection": "column", children: [_jsxs(CustomCardWrapper, { background: "linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.9)), url(".concat(trip.coverImage ? getImageUrl(trip.coverImage) : Goa, ") center/cover no-repeat"), "$maxWidth": "100%", "$justifyContent": "flex-end", 
                    /* $image={trip.coverImage || trip.galleryImages?.[0]} */
                    alignItems: "baseline", "$height": "35vh", "$cursor": "auto", children: [_jsx(CustomText, { "$color": "white", "$fontSize": "2.5rem", "$fontWeight": "900", "$padding": "0 1rem 0 1rem", children: trip.tripName }), _jsxs(CustomText, { "$color": "white", "$display": "flex", "$alignItems": "center", "$gap": "0.5rem", "$padding": "0 1rem 0 1rem", children: [_jsx(CustomIcon, { "$color": "white", children: _jsx(EventIcon, {}) }), _jsxs("span", { children: [formatTripDate(trip.startDate), " -", " ", formatTripDate(trip.endDate)] })] }), _jsxs(CustomText, { "$color": "white", "$display": "flex", "$alignItems": "center", "$gap": "0.5rem", "$padding": "0 1rem 1rem 1rem", children: [_jsx(CustomIcon, { "$color": "white", children: _jsx(LocationOnIcon, {}) }), _jsx(CustomText, { "$fontSize": "1rem", "$fontWeight": "600", "$color": "white", children: trip.destination })] })] }), _jsxs(TripDetailsBody, { children: [_jsxs(WrapperContainer, { "$justifyContent": "space-between", "$padding": "0", "$responsive": false, children: [_jsx(FeaturedIn, { categories: trip.tripCategories }), _jsxs(CustomButton, { variant: "outlined", buttonColor: "neutral", onClick: handleInviteUsersClick, children: [_jsx(CustomIcon, { "$fontSize": "inherit", children: _jsx(GroupAddIcon, { color: "action", fontSize: "small" }) }), "Share Invitation"] })] }), _jsx(DetailsCard, { title: "Trip Details", description: trip.description }), tripPrivacyInfo && (_jsxs(WrapperContainer, { "$flexDirection": "row", "$gap": "0.5rem", "$padding": "1rem", "$backgroundColor": tripPrivacyInfo.backgroundColor, "$border": "1px solid ".concat(tripPrivacyInfo.borderColor), "$borderRadius": "4px", "$margin": "1rem 0", "$alignItems": "center", "$responsive": false, children: [tripPrivacyInfo.icon && (_jsx(CustomIcon, { "$color": tripPrivacyInfo.color, "$width": "auto", style: { marginTop: "2px" }, children: _jsx(LockIcon, { fontSize: "small" }) })), _jsxs(WrapperContainer, { "$flexDirection": "column", "$padding": "0 0.5rem", "$gap": "0.25rem", children: [_jsx(CustomText, { "$fontSize": "0.9rem", "$fontWeight": "700", "$color": tripPrivacyInfo.color, children: tripPrivacyInfo.label }), _jsx(CustomText, { "$fontSize": "0.85rem", "$color": tripPrivacyInfo.color, children: tripPrivacyInfo.description })] })] })), ((_a = trip.highlights) === null || _a === void 0 ? void 0 : _a.length) ? (_jsx(DetailsCard, { title: "Highlights", description: _jsx(WrapperContainer, { "$padding": "0.5rem 0 1rem 0", children: _jsx("ul", { style: { listStyleType: "none", paddingLeft: "0" }, children: trip.highlights.map(function (item, idx) { return (_jsxs("li", { style: {
                                            display: "flex",
                                            alignItems: "flex-start",
                                            marginBottom: "8px",
                                            lineHeight: "1.4",
                                        }, children: [_jsx(CustomIcon, { "$color": "#4caf50", "$cursor": "auto", style: { marginRight: "8px", marginTop: "2px" }, children: _jsx(CheckIcon, { fontSize: "small" }) }), _jsx(CustomText, { "$fontSize": "0.95rem", children: item })] }, idx)); }) }) }) })) : null, ((_b = trip.inclusions) === null || _b === void 0 ? void 0 : _b.length) ? (_jsx(DetailsCard, { title: "Inclusions", description: _jsx("ul", { children: trip.inclusions.map(function (item, idx) { return (_jsx("li", { children: item }, idx)); }) }) })) : null, ((_c = trip.exclusions) === null || _c === void 0 ? void 0 : _c.length) ? (_jsx(DetailsCard, { title: "Exclusions", description: _jsx("ul", { children: trip.exclusions.map(function (item, idx) { return (_jsx("li", { children: item }, idx)); }) }) })) : null, ((_d = trip.itinerary) === null || _d === void 0 ? void 0 : _d.length) ? (_jsx(DetailsCard, { title: "Itinerary", description: _jsx(Box, { children: trip.itinerary.map(function (day, idx) { return (_jsxs(Box, { mb: 3, children: [_jsxs(CustomText, { "$fontSize": "1rem", "$fontWeight": "700", children: ["Day ", day.day, ": ", day.title] }), _jsx(CustomText, { "$fontSize": "0.95rem", "$color": "#555", style: { whiteSpace: "pre-wrap" }, children: day.description })] }, idx)); }) }) })) : null, trip.locationDetails && (_jsx(DetailsCard, { title: "Meeting Point", description: _jsxs(WrapperContainer, { "$flexDirection": "column", "$responsive": false, "$padding": "0", children: [_jsxs(CustomText, { "$display": "flex", "$alignItems": "center", "$gap": "0.5rem", children: [_jsx(CustomIcon, { "$color": "#1976D2", children: _jsx(LocationOnIcon, { fontSize: "small" }) }), _jsx(CustomText, { "$fontWeight": "600", children: "Location:" }), trip.locationDetails.meetingPoint] }), _jsxs(CustomText, { "$display": "flex", "$alignItems": "center", "$gap": "0.5rem", children: [_jsx(CustomIcon, { "$color": "#1976D2", children: _jsx(EventIcon, { fontSize: "small" }) }), _jsx(CustomText, { "$fontWeight": "600", children: "Time:" }), trip.locationDetails.meetingTime] })] }) })), _jsx(DetailsCard, { title: "Hosted by", description: "Shailender Pandey (BT)" }), (((_e = trip.galleryImages) === null || _e === void 0 ? void 0 : _e.length) || trip.videoUrl) && (_jsx(TripGallery, { galleryImages: trip.galleryImages, videoUrl: trip.videoUrl })), _jsx(Box, { display: "flex", gap: 1, mt: 2, children: _jsx(Chip, { label: "Status: ".concat(trip.status.replace("_", " ")), color: trip.status === "YET_TO_START" ? "primary" : "secondary", variant: "outlined" }) })] }), _jsx(WrapperContainer, { "$position": "sticky", "$padding": "0.5rem 1rem", "$bottom": "0", "$margin": "0 0 0 -1rem", "$width": "calc(100% + 2rem)", "$backgroundColor": "white", "$boxShadow": "1px -2px 7px 3px rgba(0, 0, 0, 0.1)", children: _jsx(TripActionButtons, { tripPrivacy: trip.privacySetting, userStatus: userStatus, actionLoading: actionLoading, onAcceptInvite: handleTripMembershipAction.bind(null, tripId || "", "ACCEPT_INVITE"), onDeclineInvite: handleTripMembershipAction.bind(null, tripId || "", "DECLINE_INVITE"), onJoin: handleTripMembershipAction.bind(null, tripId || "", "JOIN"), onRequestJoin: handleTripMembershipAction.bind(null, tripId || "", "REQUEST_JOIN"), onCancelRequestJoin: handleTripMembershipAction.bind(null, tripId || "", "CANCEL_REQUEST"), onLeave: handleTripMembershipAction.bind(null, tripId || "", "LEAVE") }) })] })) }));
};
export default TripDetails;
